import { twMerge } from "@/helpers/twMerge";
import { PropTypes } from "prop-types";

export const Container = ({ className, as: Component = "div", ...props }) => (
	<Component
		className={twMerge("tw:relative tw:canister tw:overflow-hidden", className)}
		role="presentation"
		{...props}
	/>
);

Container.propTypes = {
	className: PropTypes.string,
	as: PropTypes.elementType,
};
